import { IRecipientFinancialInfo } from '@nkr/models/index';

interface IState {
    data: IRecipientFinancialInfo,
    hash: string,
    allDetailsFilled: boolean,
    privateDetailsNeeded: boolean,
    medicareDetailsNeeded: boolean,
    isPrimaryInsuranceLocked: boolean,
    isSecondaryInsuranceLocked: boolean,
}

const initialState: IState = {
    data: {
        primaryGroup: 0,
        primaryDetails: '',
        secondaryGroup: 0,
        secondaryDetails: '',
        insuranceLastUpdated: '',
        isMedicarePostTransplant: null,
        medicareNumber: '',
        globalCaseRate: null,
        professionalCaseRate: false,
        relationshipToSubscriber: '',
        patientName: '',
        policyIdNumber: '',
        groupNumber: '',
        benefitPhone: '',
        precertificationPhone: '',
        healthPlanName: '',
        claimsMailingAddress: '',
        subscriberName: '',
        caseManagerName: '',
        caseManagerPhone: '',
        financialComments: '',
        isPrimaryInsuranceLocked: false,
        isSecondaryInsuranceLocked: false,
        privInsGlobalEndDays: '',
    },
    allDetailsFilled: false,
    privateDetailsNeeded: false,
    medicareDetailsNeeded: false,
    isPrimaryInsuranceLocked: false,
    isSecondaryInsuranceLocked: false,
    hash: ''
};

const financialReducer = (state: IState, action): IState => {
    if (action.type == 'afterLoad') {
        return {
            ...state,
            data: action.value.data,
            hash: action.value.hash,
            isPrimaryInsuranceLocked: action.value.isPrimaryInsuranceLocked,
            isSecondaryInsuranceLocked: action.value.isSecondaryInsuranceLocked,
        };
    }

    if (action.type == 'updateHash') {
        return { ...state, hash: action.value };
    }

    if (action.type == 'updateData') {
        return { ...state, data: action.value };
    }

    if (action.type == 'updateAllDetailsFilled') {
        return { ...state, allDetailsFilled: action.value };
    }

    if (action.type == 'toggleInsurance') {
        return { ...state, medicareDetailsNeeded: action.value.medicareDetailsNeeded, privateDetailsNeeded: action.value.privateDetailsNeeded };
    }

    return { ...state };
};

export {
    IState, initialState,
    financialReducer
};